import { getSettingSkipHCaptchaCallsForTrustworthySessions } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingSkipHCaptchaCallsForTrustworthySessions";
import postHCaptch from "@faire/web-api--source/endpoints/www/api/v2/users/retailer/hcaptcha/post";
import { ISubmitHCaptchaDataRequest } from "@faire/web-api--source/indigofair/data/ISubmitHCaptchaDataRequest";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Checks if the session is trustworthy. When it is, we can skip hCaptcha calls.
 */
export const usePrecheckSession = () => {
  const queryClient = useQueryClient();

  const fetch = useCallback(() => {
    return queryClient.fetchQuery(PRECHECK_QUERY_OPTIONS);
  }, [queryClient]);

  const refetch = useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [PRECHECK_SESSION_QUERY_KEY],
    });
    queryClient.fetchQuery(PRECHECK_QUERY_OPTIONS);
  }, [queryClient]);

  return { fetch, refetch };
};

const PRECHECK_SESSION_QUERY_KEY = "precheck-session";

const PRECHECK_QUERY_OPTIONS = {
  queryKey: [PRECHECK_SESSION_QUERY_KEY],
  queryFn: () => fetchPrecheckSession(),
  staleTime: Infinity,
  gcTime: Infinity,
};

const fetchPrecheckSession = async () => {
  if (!getSettingSkipHCaptchaCallsForTrustworthySessions()) {
    return { isTrustworthy: false };
  }

  try {
    await postHCaptch(ISubmitHCaptchaDataRequest.build({}));
    return { isTrustworthy: true };
  } catch (error) {
    return { isTrustworthy: false, error };
  }
};
